<template>
  <div class="app-main-content voucher-maintenance">
    <div class="tabs-container">
      <div class="grid-view">
        <div v-show="pageMode === 0" class="main-content voucher-list">
          <search-item
            config-module="1800"
            :reset="true"
            :custom-sim-query-placeholder="$t('SystemMaintenance.QuickSearchAdNumber')"
            @click-more="value=>isAdvancedQuery=value"
            @simSearchItemCallBack="toSimpleQuery"
            @advSearchItemCallBack="toAdvancedQuery"
          >
            <div slot="operations" class="triggers">
              <!--查看-->
              <el-button type="primary" @click="toView">{{ $t('SystemMaintenance.View') }}</el-button>
              <!--编辑-->
              <el-button type="primary" @click="toEdit">{{ $t('SystemMaintenance.Edit') }}</el-button>
              <!--启用-->
              <el-button type="primary" @click="toOpen">{{ $t('SystemMaintenance.Enable') }}</el-button>
              <!--停用-->
              <el-button type="primary" @click="toOffShelf">{{ $t('SystemMaintenance.Disable') }}</el-button>
            </div>
          </search-item>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="onReady"
            />
          </div>
          <div class="pagination-wrapper">
            <cargo-pagination
              :page-count="filter.pageCount"
              :total="filter.total"
              :page.sync="filter.pageNum"
              :limit.sync="filter.pageSize"
              @pagination="toQueryByPage"
            />
          </div>
        </div>
        <div v-show="pageMode === 1" class="main-content voucher-list">
          <ads-details ref="detail" @back="back" @refresh="refreshList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { queryASConfigFunc, updateASCFunc } from '@/api/sysManage/advertisingConfig'
import AdsDetails from '@/views/cargo/v0/SystemMaintenance/components/Ad/AdsDetail'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'AdvertisingSpaceManagement',
  components: { AdsDetails, searchItem },
  data() {
    return {
      gridParams: {},
      pageMode: 0, // 0 列表, 1 查看模式, 2 编辑模式
      loading: null,
      isAdvancedQuery: true,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        onRowSelected: this.onRowSelected,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.toView,
        pagination: false
      },
      filterJson: {
        jobNo: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      selectedDataList: [],
      selectedData: null,
      filter: {
        total: 0,
        pageNum: 1,
        pageCount: 0,
        pageSize: 10
      },
      columnDefs: [
        {
          headerName: '', field: '', width: 65, headerCheckboxSelection: true,
          checkboxSelection: true, sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false
        },
        { headerName: this.$t('SystemMaintenance.AdPositionNumber'), field: 'advertisementNo', width: 120 },
        { headerName: this.$t('SystemMaintenance.AdLocation'), field: 'title', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_INDEX_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongsToPage'), field: 'page', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_PAGE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongsToModule'), field: 'module', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.AD_MODULE_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        { headerName: this.$t('SystemMaintenance.BelongingSystem'), field: 'systemSource', width: 120 },
        { headerName: this.$t('SystemMaintenance.Status'), field: 'status', width: 120,
          valueFormatter: (params) => {
            const c = CommonState.getStateByCode(SystemConstants.ADS_STATUS_LIST, params.value)
            if (c) {
              return c.chineseName
            }
            return ''
          }
        },
        {
          headerName: this.$t('SystemMaintenance.Modifier'), field: 'modifiedBy', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('SystemMaintenance.ModificationDate'), field: 'dateModified', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('SystemMaintenance.CurrentlyPlacedAdCount'), field: 'nowPushNumber', width: 120 },
        { headerName: this.$t('SystemMaintenance.MaximumSupportedAdCount'), field: 'pushMaxNumber', width: 120 }
      ],
      rowData: []
    }
  },
  methods: {
    onReady(params) {
      this.gridApi = params.api
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.advertisementNo)
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.advertisementNo = keyword.trim()
      this.filterJson.conditions = []
      this.toQuery()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.advertisementNo = ''
      }
      this.toQuery(data)
    },
    toQuery(data) {
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading()
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      queryASConfigFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.filter.pageCount = res.data.pages
      this.selectedData = null
      this.selectedDataList = []
      this.gridApi.clearFocusedCell()
      this.loading.close()
    },
    toEdit() {
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      if (this.selectedData.status !== '3') {
        this.$message.warning(this.$t('SystemMaintenance.CurrentDisabledAndCannotEdited'))
        return
      }
      this.pageMode = 1
      this.$refs.detail.onShow(this.selectedData, 'edit', this.rowData)
    },
    toView(event) {
      if (event) {
        this.onRowClicked(event)
      }
      if (!this.selectedData || !this.selectedData.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectOneEntry'))
        return
      }
      this.pageMode = 1
      this.$refs.detail.onShow(this.selectedData, 'view', this.rowData)
    },
    refreshList(list) {
      this.rowData = list
      this.gridApi.refreshCells({ force: true })
    },
    back() {
      this.pageMode = 0
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
      this.onRowClicked(event)
    },
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedData = null
      const node = event.data
      if (node.uuid) {
        this.selectedData = node
      }
    },
    toOffShelf() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      const updateData = {}
      updateData.status = '3'
      updateData.uuids = this.selectedDataList.map(row => row.uuid)
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDisable'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        updateASCFunc(updateData).then(res => {
          if (res.data === 'ok') {
            this.updatePage(updateData.uuids, 'update3')
          } else {
            this.$message.warning(res.data)
          }
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch()
    },
    toOpen() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      const index = this.selectedDataList.findIndex(p => p.status !== '3')
      if (index !== -1) {
        this.$message.warning(this.$t('SystemMaintenance.ContainsNonDisabledData'))
        return
      }
      const updateData = {}
      updateData.status = '2'
      updateData.uuids = this.selectedDataList.map(row => row.uuid)
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToEnable'), this.$t('Message.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading()
        updateASCFunc(updateData).then(res => {
          this.updatePage(updateData.uuids, 'update2')
        }).catch((err) => {
          this.$message.error(err)
          this.loading.close()
        }).finally(() => {
          this.loading.close()
        })
      }).catch()
    },
    updatePage(uuids, action) {
      if (action === 'update2') {
        for (const d of uuids) {
          const index = this.rowData.findIndex(p => p.uuid === d)
          this.rowData[index].status = '2'
        }
        this.gridApi.refreshCells({ force: true })
      }
      if (action === 'update3') {
        for (const d of uuids) {
          const index = this.rowData.findIndex(p => p.uuid === d)
          this.rowData[index].status = '3'
        }
        this.gridApi.refreshCells({ force: true })
      }
    }
  }
}
</script>
